import React, { useEffect } from "react";
import { Login, LoginForm } from "react-admin";
import { styled } from "@mui/material/styles";

import SocialLink from "../SocialLink";
import { fetchHandleError } from "../../helpers/fetchHandleError";
import Cookies from "../../helpers/Cookies";
import { TERMS_OF_USE, PRIVACY_POLICY } from "../Constant";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";

const TermsBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "auto",
  color: "white",
}));

const MyLoginPage = (props) => {
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get("access_token");

  useEffect(() => {
    if (accessToken) {
      fetch(
        `${process.env.REACT_APP_CMS_HOST}/auth/facebook/callback?access_token=${accessToken}`
      )
        .then(fetchHandleError)
        .then((data) => {
          const { jwt } = data;
          Cookies.setCookie("token", jwt, 7);
        });
    }
  }, [accessToken]);

  return (
    <div>
      <Login>
        <LoginForm />
        <SocialLink provider={"facebook"} />

        <TermsBox>
          <strong>
            By logging in, you are agreeing to our{" "}
            <a target="_blank" rel="noreferrer noopener" href={TERMS_OF_USE}>
              Terms of Use
            </a>{" "}
            and{" "}
            <a target="_blank" rel="noreferrer noopener" href={PRIVACY_POLICY}>
              Privacy Policy
            </a>
            .
          </strong>
        </TermsBox>
      </Login>
    </div>
  );
};

export default MyLoginPage;
